interface BrandWordmarkProps {
    className?: string;
    animated?: boolean;
}

export default function BrandWordmark({ className = '', animated = true }: BrandWordmarkProps) {
    return (
        <span className={`${animated ? 'brand-wordmark' : 'brand-wordmark-static'} ${className}`}>
            <span className="sr-only">DARK TR0JAN</span>
            <span aria-hidden="true">
                <span className="brand-word">DARK</span>{' '}
                <span className="brand-word">TR<span className="brand-zero">0</span>JAN</span>
            </span>
        </span>
    );
}
